import { BOOKING_DATE, JOURNEY_DATE, tCommon } from "../../translations/Common";
import {
  Ac,
  NonAc,
  Seater,
  Sleeper,
  Volvo,
  Evening,
  Afternoon,
  Morning,
} from "./icons/svg";

export const apiUrl = {
  // GET ? fromCityID | toCityID | fromCityName | toCityName | journeyDate | mode
  search: "/api/resource/searchRoutesV4",
  // GET ? tripId | chartDate | fromCity | toCity
  track: "/api/others/GetGPSLocationURL",

  // GET ? routeID
  routeInfo: "/api/resource/getRouteInfo",
  // GET ? tripid | chartDate
  serviceRouteInfo: "/api/resource/APIMSTripsSummaryPkpDrp",
  // GET ? routeID | journeyDate
  chart: "/api/resource/seatArrangement",
  // POST
  orderSave: "/api/expco/ordersave",
  // GET ? token
  orderDetails: "/api/expco/getOrderDetails",
  //GeT
  APIMicrositeBookingDetails: "/api/resource/APIMicrositeBookingDetails",
  // GET ? RouteCode | SeatLabel_ | Gender_
  genderValidate: "/api/resource/APIGenderValidate",
  // GET ? RouteCode | MobileNumber | EmailID | CouponName
  couponList: "/api/resource/APICouponCardListAll",
  // GET ? RouteCode | MobileNumber | Email | CouponName | OpDiscount | TotalFare | CouponName2 | CouponName3 | IsLoggedin | ServiceCharge | Stax
  //couponRedeem: '/api/resource/APIRedeemCouponv4',
  couponRedeem: "/api/resource/APIRedeemCouponv5",
  // GET ? RouteCode | MobileNumber | OTP | CouponName | OpDiscount | TotalFare | CouponName2 | CouponName3 | ServiceCharge | Stax
  couponValidate: "/api/resource/APIvalidateCouponOTPV4",
  // GET ? mobile | prepaid_no
  prepaidDetails: "/api/others/prepaid_card_details",
  // POST
  prepaidSave: "/api/expco/prepaidCardOrderSave",
  // GET ? mobile | otptype=PD
  generateOTP: "/api/resource/GenerateOTP",
  // GET ? OTP | otptype=PD
  validateOTP: "/api/resource/APIValidateAgentOTPLogin",
  saveProfile: "/my_profile/saveProfile",
  //GET ? RouteCode
  middlecities: "/api/resource/ActiveMiddleCities",
  //GET ? agent_id or msurl  any of them
  ismantispg: "/api/resource/ismantispg",
  //GET ? mobile_number , siteurl if needed
  getlogintoken: "/api/resource/APIGetlogintoken",
  //POST
  waitlist: "/api/others/paxWaitList",
  //GET ? tripId , chartDate
  tripSummaryPKpDrp: "/api/resource/APIMSTripsSummaryPkpDrp",
  // GET ? fromCityID | toCityID | journeyDate
  searchPkpDrp: "/api/resource/searchRoutesPkpDrp",
  // GET ? RouteCode
  getConcessionAndLevy: "/api/resource/getConcessionAndLevy",
  // POST ? userName | password
  checkoutLogin: "/api/resource/checkoutLogin",
  //Get
  SendSignupOtp: "/api/resource/SendSignupOtp",
  //POST
  APISignup: "/api/resource/APISignup",
  //POST
  userLogin: "/api/resource/userLogin",
  //GET
  userPwdOtp: "/api/resource/userPwdOtp",
  //POST
  userResetPwd: "/api/resource/userResetPwd",
  //GET
  getUserDetails: "/api/resource/getUserDetailsV1",
  //POSt
  editUserDetails: "/api/resource/editUserDetailsV1",
  //GET
  bookingInfo: "/api/resource/BookingInfo",
  //GET
  cancelConfirm: "/api/ticket/cancelConfirm",
  //GET
  calculateCancellationCharges: "/api/resource/calculateCancellationCharges",
  //GET
  sendBookingTicket: "/api/resource/sendBookingTicket",
  //POST
  pnrCancelRequest: "/api/resource/pnrCancelRequest",
  //GET
  editBooking: "/api/resource/editBooking",
  //GET
  getTimeTable: "/api/resource/getTimeTable",
  getStaticCity: "/api/resource/getStaticCityList",
  getCityList: "/api/resource/getCityList",
  getBookingByUserId: "/api/resource/getBookingByUserId",
  // POST
  deleteProfile: "/api/resource/deleteProfile",

  //GET
  validateTxnPwd: '/api/resource/validateTxnPwd',
  getBusImage: '/api/resource/getBusImage',
  validateCaptcha: '/api/resource/validateCaptcha',
  validPnr: '/api/resource/validPnr',
  updateTxnPwd: '/api/resource/updateTxnPwd',

  //FEED BACK 
  getFeedbackDetsByPnr: "/api/resource/getFeedbackDetsByPnr", // GET
  submitFeedback: "/api/resource/submitFeedback", // Post
  getFeedbackDets: "/api/resource/getFeedbackDets", // GET

  getMobNo: '/api/resource/getMobileNoFromPnr',

  generateOTPV2: "/api/resource/generateOTPV2",
  validateOTPV2: "/api/resource/validateOTPV2",
  getcountryCode: '/api/resource/countryCode',

  //POSt
  editUserMobile: "/api/resource/editUserMobile",

  //post
  markFavourite: "/api/resource/markFavourite",

  getTourPackageData: "/api/resource/getTourPackageData",
  getBusID: "/api/resource/getBusID",
  getPickUpID: "/api/resource/getPickUpID",
  getAccoType: "/api/resource/getAccoType",
  getSeatLayoutData: "/api/resource/getSeatLayoutData",
  getFare: "/api/resource/getFare",
  getSeniorFare: "/api/resource/getSeniorFare",
  packageOrderSave: "/api/package/packageOrdersave",
  packageOrderDetails: "/api/package/getpackageOrderDetails",

  packageValidPnr: '/api/package/packageValidPnr',
  packageValidateTxnPwd: '/api/package/packageValidateTxnPwd',
  packageUpdateTxnPwd: '/api/package/packageUpdateTxnPwd',
  packageGetBookingByUserId: '/api/package/packageGetBookingByUserId',
  packageBookingInfo: "/api/package/packageBookingInfo",
  packageBusSeatsCancellationCharges: "/api/package/packageBusSeatsCancellationCharges",
  packageBusSeatsCancellation: "/api/package/packageBusSeatsCancellation",
  packageAvailableTripDates: "/api/package/packageAvailableTripDates",
};

export const color = {
  primary: window.color.searchBoxBgColor || "#0089CF",
  secondary: window.color.buttonColor || "#F15A22",
  couponBackground: window.color.offerBoxBgColor || "#FCFBB7",
  blue: "#01AEF0",
};

export const Rs =
  window.location.hostname === "busdemo.travels.com.mm"
    ? "K"
    : window.location.hostname === "easybuscoach.buscrs.com"
      ? "/="
      : window.msurl === "shwesanthu.com"
        ? "Ks"
        : window.msurl === "moventis.iamgds.com"
          ? "SAR "
          : "₹";

export const bustypeFilter = [
  {
    name: "AC",
    svg: "Ac",
  },
  {
    name: "Non AC",
    svg: "NonAc",
  },
  {
    name: "Seater",
    svg: "Seater",
  },
  {
    name: "Sleeper",
    svg: "Sleeper",
  }/* ,
  {
    name: "Premium",
    svg: "",
  } */,
];

export const timeFilter = [
  {
    name: "Morning",
    time: "00:00 - 12:00",
    svg: "Morning",
  },
  {
    name: "Afternoon",
    time: "12:00 - 18:00",
    svg: "Afternoon",
  },
  {
    name: "Evening",
    time: "18:00 - 00:00",
    svg: "Evening",
  },
];

export const timeFilterNew = [
  {
    name: "Early Morning (Before 10:00 Hrs.)",
    time: "00:00 - 10:00",
    value: "Morning",
  },
  {
    name: "Day (10:00 - 17:00 Hrs.)",
    time: "10:01 - 17:00",
    value: "Day",
  },
  {
    name: "Evening (17:01 - 23:00 Hrs.)",
    time: "17:01 - 23:00",
    value: "Evening",
  },
  {
    name: "Late Night (After 23:01 Hrs.)",
    time: "23:01 - 00:00",
    value: "Night",
  },
];

export const idCardTypes = [
  {
    name: "AADHAR",
  },
  {
    name: "Company ID",
  },
  {
    name: "Driving License",
  },
  {
    name: "Educational ID",
  },
  {
    name: "Govt. ID",
  },
  {
    name: "PAN",
  },
  {
    name: "Passport",
  },
  {
    name: "Ration Card",
  },
  {
    name: "Senior citizen ID",
  },
  {
    name: "Voter ID",
  },
];

export const nationalityData = [
  {
    name: "Afghan",
  },
  {
    name: "Albanian",
  },
  {
    name: "Algerian",
  },
  {
    name: "American",
  },
  {
    name: "Andorran",
  },
  {
    name: "Angolan",
  },
  {
    name: "Antiguans",
  },
  {
    name: "Argentinean",
  },
  {
    name: "Armenian",
  },
  {
    name: "Australian",
  },
  {
    name: "Austrian",
  },
  {
    name: "Azerbaijani",
  },
  {
    name: "Bahamian",
  },
  {
    name: "Bahraini",
  },
  {
    name: "Bangladeshi",
  },
  {
    name: "Barbadian",
  },
  {
    name: "Barbudans",
  },
  {
    name: "Batswana",
  },
  {
    name: "Belarusian",
  },
  {
    name: "Belgian",
  },
  {
    name: "Belizean",
  },
  {
    name: "Beninese",
  },
  {
    name: "Bhutanese",
  },
  {
    name: "Bolivian",
  },
  {
    name: "Bosnian",
  },
  {
    name: "Brazilian",
  },
  {
    name: "British",
  },
  {
    name: "Bruneian",
  },
  {
    name: "Bulgarian",
  },
  {
    name: "Burkinabe",
  },
  {
    name: "Burmese",
  },
  {
    name: "Burundian",
  },
  {
    name: "Cambodian",
  },
  {
    name: "Cameroonian",
  },
  {
    name: "Canadian",
  },
  {
    name: "Cape Verdean",
  },
  {
    name: "Central African",
  },
  {
    name: "Chadian",
  },
  {
    name: "Chilean",
  },
  {
    name: "Chinese",
  },
  {
    name: "Colombian",
  },
  {
    name: "Comoran",
  },
  {
    name: "Congolese",
  },
  {
    name: "Costa Rican",
  },
  {
    name: "Croatian",
  },
  {
    name: "Cuban",
  },
  {
    name: "Cypriot",
  },
  {
    name: "Czech",
  },
  {
    name: "Danish",
  },
  {
    name: "Djibouti",
  },
  {
    name: "Dominican",
  },
  {
    name: "Dutch",
  },
  {
    name: "East Timorese",
  },
  {
    name: "Ecuadorean",
  },
  {
    name: "Egyptian",
  },
  {
    name: "Emirian",
  },
  {
    name: "Equatorial Guinean",
  },
  {
    name: "Eritrean",
  },
  {
    name: "Estonian",
  },
  {
    name: "Ethiopian",
  },
  {
    name: "Fijian",
  },
  {
    name: "Filipino",
  },
  {
    name: "Finnish",
  },
  {
    name: "French",
  },
  {
    name: "Gabonese",
  },
  {
    name: "Gambian",
  },
  {
    name: "Georgian",
  },
  {
    name: "German",
  },
  {
    name: "Ghanaian",
  },
  {
    name: "Greek",
  },
  {
    name: "Grenadian",
  },
  {
    name: "Guatemalan",
  },
  {
    name: "Guinea-Bissauan",
  },
  {
    name: "Guinean",
  },
  {
    name: "Guyanese",
  },
  {
    name: "Haitian",
  },
  {
    name: "Herzegovinian",
  },
  {
    name: "Honduran",
  },
  {
    name: "Hungarian",
  },
  {
    name: "I-Kiribati",
  },
  {
    name: "Icelander",
  },
  {
    name: "Indian",
  },
  {
    name: "Indonesian",
  },
  {
    name: "Iranian",
  },
  {
    name: "Iraqi",
  },
  {
    name: "Irish",
  },
  {
    name: "Israeli",
  },
  {
    name: "Italian",
  },
  {
    name: "Ivorian",
  },
  {
    name: "Jamaican",
  },
  {
    name: "Japanese",
  },
  {
    name: "Jordanian",
  },
  {
    name: "Kazakhstani",
  },
  {
    name: "Kenyan",
  },
  {
    name: "Kittian and Nevisian",
  },
  {
    name: "Kuwaiti",
  },
  {
    name: "Kyrgyz",
  },
  {
    name: "Laotian",
  },
  {
    name: "Latvian",
  },
  {
    name: "Lebanese",
  },
  {
    name: "Liberian",
  },
  {
    name: "Libyan",
  },
  {
    name: "Liechtensteiner",
  },
  {
    name: "Lithuanian",
  },
  {
    name: "Luxembourger",
  },
  {
    name: "Macedonian",
  },
  {
    name: "Malagasy",
  },
  {
    name: "Malawian",
  },
  {
    name: "Malaysian",
  },
  {
    name: "Maldivan",
  },
  {
    name: "Malian",
  },
  {
    name: "Maltese",
  },
  {
    name: "Marshallese",
  },
  {
    name: "Mauritanian",
  },
  {
    name: "Mauritian",
  },
  {
    name: "Mexican",
  },
  {
    name: "Micronesian",
  },
  {
    name: "Moldovan",
  },
  {
    name: "Monacan",
  },
  {
    name: "Mongolian",
  },
  {
    name: "Moroccan",
  },
  {
    name: "Mosotho",
  },
  {
    name: "Motswana",
  },
  {
    name: "Mozambican",
  },
  {
    name: "Namibian",
  },
  {
    name: "Nauruan",
  },
  {
    name: "Nepalese",
  },
  {
    name: "New Zealander",
  },
  {
    name: "Nicaraguan",
  },
  {
    name: "Nigerian",
  },
  {
    name: "Nigerien",
  },
  {
    name: "North Korean",
  },
  {
    name: "Northern Irish",
  },
  {
    name: "Norwegian",
  },
  {
    name: "Omani",
  },
  {
    name: "Pakistani",
  },
  {
    name: "Palauan",
  },
  {
    name: "Panamanian",
  },
  {
    name: "Papua New Guinean",
  },
  {
    name: "Paraguayan",
  },
  {
    name: "Peruvian",
  },
  {
    name: "Polish",
  },
  {
    name: "Portuguese",
  },
  {
    name: "Qatari",
  },
  {
    name: "Romanian",
  },
  {
    name: "Russian",
  },
  {
    name: "Rwandan",
  },
  {
    name: "Saint Lucian",
  },
  {
    name: "Salvadoran",
  },
  {
    name: "Samoan",
  },
  {
    name: "San Marinese",
  },
  {
    name: "Sao Tomean",
  },
  {
    name: "Saudi",
  },
  {
    name: "Scottish",
  },
  {
    name: "Senegalese",
  },
  {
    name: "Serbian",
  },
  {
    name: "Seychellois",
  },
  {
    name: "Sierra Leonean",
  },
  {
    name: "Singaporean",
  },
  {
    name: "Slovakian",
  },
  {
    name: "Slovenian",
  },
  {
    name: "Solomon Islander",
  },
  {
    name: "Somali",
  },
  {
    name: "South African",
  },
  {
    name: "South Korean",
  },
  {
    name: "Spanish",
  },
  {
    name: "Sri Lankan",
  },
  {
    name: "Sudanese",
  },
  {
    name: "Surinamer",
  },
  {
    name: "Swazi",
  },
  {
    name: "Swedish",
  },
  {
    name: "Swiss",
  },
  {
    name: "Syrian",
  },
  {
    name: "Taiwanese",
  },
  {
    name: "Tajik",
  },
  {
    name: "Tanzanian",
  },
  {
    name: "Thai",
  },
  {
    name: "Togolese",
  },
  {
    name: "Tongan",
  },
  {
    name: "Trinidadian or Tobagonian",
  },
  {
    name: "Tunisian",
  },
  {
    name: "Turkish",
  },
  {
    name: "Tuvaluan",
  },
  {
    name: "Ugandan",
  },
  {
    name: "Ukrainian",
  },
  {
    name: "Uruguayan",
  },
  {
    name: "Uzbekistani",
  },
  {
    name: "Venezuelan",
  },
  {
    name: "Vietnamese",
  },
  {
    name: "Welsh",
  },
  {
    name: "Yemenite",
  },
  {
    name: "Zambian",
  },
  {
    name: "Zimbabwean",
  },
];

export const countryCodeData = [
  {
    name: "India +91",
    id: "+91",
  },
];

export const genderTypeData = [
  {
    name: "Male",
    svg: "male-icon",
    color: "#0086FF",
  },
  {
    name: "Female",
    svg: "female-icon",
    color: "#EC1287",
  },
  {
    name: "Others",
    svg: "others-icon",
    color: "#444444",
  },
];
export const indianStatesAndUTs = [
  { id: 1, name: "Andaman and Nicobar Islands", type: "Union Territory" },
  { id: 2, name: "Andhra Pradesh", type: "State" },
  { id: 3, name: "Arunachal Pradesh", type: "State" },
  { id: 4, name: "Assam", type: "State" },
  { id: 5, name: "Bihar", type: "State" },
  { id: 6, name: "Chandigarh", type: "Union Territory" },
  { id: 7, name: "Chhattisgarh", type: "State" },
  {
    id: 8,
    name: "Dadra and Nagar Haveli and Daman and Diu",
    type: "Union Territory",
  },
  { id: 9, name: "Delhi", type: "Union Territory" },
  { id: 10, name: "Goa", type: "State" },
  { id: 11, name: "Gujarat", type: "State" },
  { id: 12, name: "Haryana", type: "State" },
  { id: 13, name: "Himachal Pradesh", type: "State" },
  { id: 14, name: "Jammu and Kashmir", type: "Union Territory" },
  { id: 15, name: "Jharkhand", type: "State" },
  { id: 16, name: "Karnataka", type: "State" },
  { id: 17, name: "Kerala", type: "State" },
  { id: 18, name: "Ladakh", type: "Union Territory" },
  { id: 19, name: "Lakshadweep", type: "Union Territory" },
  { id: 20, name: "Madhya Pradesh", type: "State" },
  { id: 21, name: "Maharashtra", type: "State" },
  { id: 22, name: "Manipur", type: "State" },
  { id: 23, name: "Meghalaya", type: "State" },
  { id: 24, name: "Mizoram", type: "State" },
  { id: 25, name: "Nagaland", type: "State" },
  { id: 26, name: "Odisha", type: "State" },
  { id: 27, name: "Puducherry", type: "Union Territory" },
  { id: 28, name: "Punjab", type: "State" },
  { id: 29, name: "Rajasthan", type: "State" },
  { id: 30, name: "Sikkim", type: "State" },
  { id: 31, name: "Tamil Nadu", type: "State" },
  { id: 32, name: "Telangana", type: "State" },
  { id: 33, name: "Tripura", type: "State" },
  { id: 34, name: "Uttar Pradesh", type: "State" },
  { id: 35, name: "Uttarakhand", type: "State" },
  { id: 36, name: "West Bengal", type: "State" },
];
export const sortOrders = [
  {
    id: 0,
    name: `${tCommon(BOOKING_DATE)}`,
    sortKey: "BookingDateTime",
  },
  {
    id: 1,
    name: `${tCommon(JOURNEY_DATE)}`,
    sortKey: "DepartureTime",
  },
];

export const requestTypeData = [
  {
    name: "Cancellation Request",
    id: "1",
  },
];
